import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { Layout } from '@storable/canaveral-components';
import { BUILDER, BLOG, NON_FACILITY_PAGES, FACILITY_PAGES } from 'shared/abilities';
import { openSiteStylesModal } from 'web/store/modules/pageBuilder';
import AdminSiteStylesModal from '../containers/AdminSiteStylesModal';
import AdminAddPageModal from '../containers/AdminAddPageModal';
import AdminLayoutNavbarButton from '../../../../admin/containers/AdminLayoutNavbarButton';
import AdminSoftwareNavbarItem from '../containers/AdminSoftwareNavbarItem';
import AdminSettingsNavbarItem from '../containers/AdminSettingsNavbarItem';
import AdminRentalCenterNavbarItem from '../../../../admin/containers/AdminRentalCenterNavbarItem';
import AdminMediaGalleryNavbarItem from '../../../../admin/containers/AdminMediaGalleryNavbarItem';
import AdminNavbarItem from './AdminNavbarItem';

const itemPropTypes = PropTypes.shape({
  authorization: PropTypes.shape({
    action: PropTypes.string,
    subject: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.string),
    ]),
  }),
  icon: PropTypes.string,
  text: PropTypes.string,
});

const propTypes = {
  add: itemPropTypes,
  blog: itemPropTypes,
  home: itemPropTypes,
  mediaGallery: itemPropTypes,
  panel: PropTypes.element,
  settings: itemPropTypes,
  styles: itemPropTypes,
  showStylesModal: PropTypes.bool.isRequired,
  openStylesModal: PropTypes.func.isRequired,
};

const defaultProps = {
  add: undefined,
  blog: undefined,
  home: undefined,
  mediaGallery: undefined,
  panel: undefined,
  settings: undefined,
  styles: undefined,
};

const ADD_MODAL = 'add';

const AdminNavbar = ({
  add,
  blog,
  home,
  mediaGallery,
  panel,
  settings,
  styles,
  openStylesModal,
  facilityId,
}) => {
  const [show, setShow] = useState();

  const onOpenModal = modal => () => setShow(modal);

  const onCloseModal = () => setShow();

  return (
    <React.Fragment>
      <Layout.Navbar panel={panel}>
        <AdminNavbarItem
          to="/admin"
          icon="all-pages"
          text="Pages"
          componentClass={Link}
          {...home}
        />
        <AdminNavbarItem
          icon="add"
          text="Add Page"
          authorization={{
            action: 'manage',
            subject: BUILDER,
            text: 'add a page to this site',
          }}
          componentClass="button"
          onClick={onOpenModal(ADD_MODAL)}
          {...add}
        />
        <AdminNavbarItem
          text="Styles"
          icon="styles"
          componentClass="button"
          authorization={{
            action: 'manage',
            subject: [NON_FACILITY_PAGES, FACILITY_PAGES],
            text: 'modify branding',
          }}
          onClick={() => openStylesModal(facilityId)}
          {...styles}
        />
        <AdminLayoutNavbarButton />
        <AdminNavbarItem
          text="Blog"
          icon="blog"
          to="/admin/blog"
          authorization={{
            action: 'manage',
            subject: BLOG,
            text: 'edit the blog',
          }}
          componentClass={Link}
          {...blog}
        />
        <AdminMediaGalleryNavbarItem {...mediaGallery} />
        <AdminSettingsNavbarItem {...settings} />
        <AdminRentalCenterNavbarItem />
        <AdminSoftwareNavbarItem />
      </Layout.Navbar>
      <AdminAddPageModal
        show={show === ADD_MODAL}
        onDismiss={onCloseModal}
      />
      <AdminSiteStylesModal />
    </React.Fragment>
  );
};

AdminNavbar.propTypes = propTypes;
AdminNavbar.defaultProps = defaultProps;

export default connect(
  state => ({
    facilityId: state.pageBuilder.facilityId,
  }),
  dispatch => ({
    openStylesModal: facilityId => dispatch(openSiteStylesModal(facilityId)),
  }),
)(AdminNavbar);
